var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#54B038"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6399 15.768C10.552 15.768 10.4641 15.7488 10.3863 15.7195C10.0053 15.573 9.81945 15.1526 9.95682 14.7717L12.8871 6.95796C13.0336 6.57702 13.4539 6.39112 13.8349 6.52849C14.2158 6.67501 14.4017 7.09533 14.2643 7.47626L11.334 15.29C11.2269 15.583 10.943 15.7689 10.65 15.7689L10.6399 15.768Z",
    fill: "#F2ECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.384 13.8148C21.0808 13.8148 20.7878 13.6197 20.6908 13.3166L18.7376 7.45607C18.6103 7.07513 18.8154 6.65481 19.1963 6.52846C19.5873 6.40117 19.9976 6.60629 20.1239 6.98722L22.0771 12.8478C22.2044 13.2287 21.9993 13.649 21.6184 13.7754C21.5405 13.8047 21.4618 13.8148 21.384 13.8148Z",
    fill: "#F2ECEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2913 12.3497H13.4045L12.301 15.29C12.1939 15.583 11.91 15.7689 11.617 15.7689C11.5291 15.7689 11.4412 15.7497 11.3633 15.7204C10.9824 15.5739 10.7965 15.1536 10.9339 14.7726L11.8423 12.3405L7.70964 12.3396C6.77195 12.3396 6 13.1116 6 14.0492V14.9283C6 15.0355 6.01007 15.1527 6.0293 15.2607L7.49444 22.5763C7.83599 24.286 9.35059 25.5167 11.0886 25.5167H21.9114C23.6503 25.5167 25.164 24.2759 25.5056 22.5763L26.9707 15.2607C26.9899 15.1536 27 15.0364 27 14.9283V14.0492C27 13.1116 26.228 12.3396 25.2904 12.3396L25.2913 12.3497ZM17.9656 17.7222H15.0353C14.6352 17.7222 14.3028 17.3897 14.3028 16.9896C14.3028 16.5894 14.6352 16.257 15.0353 16.257H17.9656C18.3658 16.257 18.6982 16.5894 18.6982 16.9896C18.6982 17.3897 18.3658 17.7222 17.9656 17.7222Z",
    fill: "#F2ECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFav);
export default __webpack_public_path__ + "static/media/activeFav.f06abb56cac970a06f6698d58162aabd.svg";
export { ForwardRef as ReactComponent };